import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import 'react-toastify/dist/ReactToastify.css';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ModalBox from '../ModalBox';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import { allNotifications } from '../../utils/toastify';
import services from '../../services/services';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import CardBoxTreatmentPlan from '../CardBoxTreatmentPlan';
import NewProcedure from '../NewProcedure';
import NewGtoType from '../../components/NewGtoType';
import { Row, Input } from 'react-materialize';

const { notifyErrorBottomRight } = allNotifications;

class Procedure extends React.Component {
  state = {
    modalActive: false,
    procedure: null,
    proceduresGTO: [],
    alertCreatedGto: false,
    alertPreAprovacao: false,
    alertGtoExclusivaMsg: '',
    alertGtoExclusiva: false,
    numeroGto: 0,
    procedimentosExclusivos: [],
    observacoes: '',
    gtoType: 1
  };
  componentWillMount = () => {
    this.buscarProcedimentosExclusivos();
  };

  componentDidMount = () => {
    if (this.state.proceduresGTO.length === 0) {
      this.setState(state => ({
        modalActive: !state.modalActive
      }));
    } else {
      this.setState({ btnDisabled: false });
    }
  };

  toggleCreate = procedure => {
    if (procedure) {
      this.setState(state => ({
        modalActive: !state.modalActive,
        procedure
      }));
    } else {
      this.setState(state => ({
        modalActive: !state.modalActive,
        procedure: null
      }));
    }
  };

  buscarProcedimentosExclusivos = async () => {
    services
      .mobileengine('buscarProcedimentosExclusivos', {})
      .then(response => this.setState({ procedimentosExclusivos: response }));
  };

  validateGtoExclusiva = procedure => {
    const { proceduresGTO } = this.state;

    if (proceduresGTO.length > 0) {
      if (procedure.tipoProcedimento === undefined) {
        const gtoExclusiva = proceduresGTO.find(proc => proc.tipoProcedimento !== undefined);
        if (gtoExclusiva) {
          this.setState({
            alertGtoExclusiva: !this.state.alertGtoExclusiva,
            alertGtoExclusivaMsg: `O procedimento ${gtoExclusiva.codigo} deve ser faturado separadamente em GTO exclusiva.`
          });

          return false;
        }
      } else if (procedure.tipoProcedimento !== null) {
        this.setState({
          alertGtoExclusiva: !this.state.alertGtoExclusiva,
          alertGtoExclusivaMsg: `O procedimento ${procedure.codigo} deve ser faturado separadamente em GTO exclusiva.`
        });

        return false;
      }
    }

    return true;
  };

  validateGto = procedure => {
    const { proceduresGTO } = this.state;
    let validGto = true;
    const procedimentosOrto = ['86000357', '86000365', '86000373', '86000400', '98764004'];

    if (proceduresGTO.length > 0) {
      let jaPossui;

      if (procedure.tooth && procedure.face) {
        jaPossui = proceduresGTO.find(
          proc =>
            proc.codigo === procedure.codigo &&
            proc.tooth === procedure.tooth &&
            proc.face === procedure.face &&
            proc.id !== procedure.id
        );
      } else if (procedure.tooth) {
        jaPossui = proceduresGTO.find(
          proc =>
            proc.codigo === procedure.codigo &&
            proc.tooth === procedure.tooth &&
            proc.id !== procedure.id
        );
      } else if (procedure.region) {
        jaPossui = proceduresGTO.find(
          proc =>
            proc.codigo === procedure.codigo &&
            proc.region === procedure.region &&
            proc.id !== procedure.id
        );
      } else if (procedure.face) {
        jaPossui = proceduresGTO.find(
          proc =>
            proc.codigo === procedure.codigo &&
            proc.face === procedure.face &&
            proc.id !== procedure.id
        );
      }

      if (procedimentosOrto.includes(procedure.codigo)
        && proceduresGTO.find(
          proc =>
            procedimentosOrto.includes(proc.codigo)
        )) {
        jaPossui = false
      }

      validGto = jaPossui === undefined;
    }

    return validGto;
  };

  deleteProcedure = procedure => {
    const { proceduresGTO } = this.state;
    this.setState({
      proceduresGTO: proceduresGTO.filter(proc => proc.id !== procedure.id)
    });
  };

  editProcedure = procedure => {
    const { proceduresGTO } = this.state;
    const gtoValida = this.validateGto(procedure);

    if (gtoValida) {
      this.setState(
        {
          proceduresGTO: proceduresGTO.map(proc => (proc.id === procedure.id ? procedure : proc))
        },
        () => this.toggleCreate()
      );
    } else {
      notifyErrorBottomRight('Procedimento já existe');
    }
  };

  editGtoType = gtotype => {
    this.state.gtoType = gtotype;
  };

  handleObservacao = e => {
    const { value } = e.target;

    this.setState({ observacoes: value });
  };

  addProcedure = procedure => {
    const gtoValida = this.validateGto(procedure);

    const { procedimentosExclusivos } = this.state;
    const possuiNaLista = procedimentosExclusivos.find(
      procExclusivo => procExclusivo.codigo_procedimento === procedure.codigo
    );
    if (possuiNaLista) {
      procedure.tipoProcedimento = possuiNaLista.tipo_procedimento;
    }

    const gtoExclusiva = this.validateGtoExclusiva(procedure);

    if (this.state.proceduresGTO.length > 7) {
      notifyErrorBottomRight('Você atingiu a quantidade máxima de procedimentos (8) por GTO. Para mais inclusões, faça uma nova solicitação.')
    } else if (gtoValida && gtoExclusiva) {
      this.setState(
        prevState => ({
          proceduresGTO: [...prevState.proceduresGTO, procedure]
        }),
        () => {
          this.toggleCreate();

          if (this.state.btnDisabled) {
            this.setState({ btnDisabled: false });
          }
        }
      );
    } else if (!gtoValida) {
      notifyErrorBottomRight('Procedimento já existe');
    }
  };

  handleCreateGto = () => {
    this.setState({ btnDisabled: true });

    const { proceduresGTO } = this.state;
    const codigoPrestador = this.props.codigo;
    const codigoBeneficiario = this.props.updatedPlans.numero_carteirinha;
    const tipoatendimento = this.state.gtoType;
    const nomesocial = localStorage.getItem("socialname" + this.props.updatedPlans.numero_carteirinha);
    const observacoes = this.state.observacoes;

    // Cria objeto de procedimentos, esperado pelo serviço
    const procedimentos = [];
    proceduresGTO.forEach(procedure => {
      const procedimento = {
        codigo_procedimento: procedure.codigo,
        dente_regiao: procedure.tooth ? procedure.tooth : procedure.region,
        face: procedure.face
      };
      procedimentos.push(procedimento);
    });

    // Chama serviço para obtenção do número atual do contrato do beneficiário
    services
      .beneficiario('getContractNumber', codigoBeneficiario)
      .then(responseContrato => {
        const dadosGuia = {
          contrato: responseContrato.contrato,
          procedimentos,
          tipoatendimento,
          nomesocial,
          observacoes
        };
        services
          .mobileengine('adicionarGto', {
            codigoBeneficiario,
            codigoPrestador,
            dadosGuia
          })
          .then(response => {
            this.setState({
              numeroGto: response.numero_gto,
              alertCreatedGto: !this.state.alertCreatedGto
            });
          })
          .catch(err => {
            if (err.message.includes('solicitação de manutenção')) {
              this.setState({
                alertPreAprovacao: true
              });
            } else {
              notifyErrorBottomRight(`Erro ao criar GTO: ${err.message}`);
              if (proceduresGTO.length > 0) {
                this.setState({ btnDisabled: false });
              }
              this.props.history.goBack();
            }
          });
      })
      .catch(err => {
        notifyErrorBottomRight(err.message);
        if (proceduresGTO.length > 0) {
          this.setState({ btnDisabled: false });
        }
        this.props.history.goBack();
      });
  };

  handleOkCriar = () => {
    this.props.history.push({
      pathname: '/detalhes-gto',
      state: {
        gtoId: this.state.numeroGto,
        credenId: this.props.codigo,
        data: this.props.updatedPlans,
        regANS: this.props.regANS
      }
    });
    this.setState({ alertCreatedGto: false });
  };

  handleBadRequestPreAprovacaoOrto = () => {
    this.props.history.goBack();
    this.setState({ alertCreatedGto: false });
  };

  render() {
    const { updatedPlans } = this.props;
    const {
      proceduresGTO,
      alertGtoExclusiva,
      alertCreatedGto,
      alertPreAprovacao,
      procedure,
      alertGtoExclusivaMsg,
      modalActive,
      btnDisabled
    } = this.state;

    return (
      <>
        <CardBoxTreatmentPlan type="blue" data={updatedPlans} />
        <ExpansionPanel id="procedure-panel">
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            className="panel-header"
          >
            <p className="card-label" style={{ marginTop: 3, color: '1b365d' }}>
              <span className="txt-procedure" style={{ color: '#208dbb' }}>Informações Adicionais</span>
            </p>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className="procedure-panel-details">
            <p className="card-label">
              <span><NewGtoType data={updatedPlans} editGtoType={this.editGtoType}></NewGtoType></span></p>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <Tooltip title="Use o botão para inserir a quantidade máxima de até 8 procedimentos por GTO.">
          <Fab
            className="btn-adicionar"
            color="primary"
            aria-label="add"
            onClick={() => this.toggleCreate()}
          >
            <AddIcon />
          </Fab>
        </Tooltip>

        <ToastContainer />

        {proceduresGTO &&
          proceduresGTO.map(procedure => (
            <ExpansionPanel key={procedure.id} id="procedure-panel">
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                className="panel-header"
              >
                <p className="card-label" style={{ marginTop: 8 }}>
                  <span className="txt-procedure">{procedure.descricao}</span>
                </p>

                {procedure.face && (
                  <p className="card-label">
                    <span>{`Face: ${procedure.face}`}</span>
                  </p>
                )}
                {procedure.tooth && (
                  <p className="card-label">
                    <span>{`Dente: ${procedure.tooth}`}</span>
                  </p>
                )}
                {procedure.region && (
                  <p className="card-label">
                    <span>{`Região: ${procedure.region}`}</span>
                  </p>
                )}
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className="procedure-panel-details">
                <Button
                  className="btn btn-excluir"
                  startIcon={<DeleteIcon />}
                  variant="outlined"
                  onClick={() => this.deleteProcedure(procedure)}
                  disableElevation
                >
                  Excluir
                </Button>
                <Button
                  className="btn btn-editar"
                  startIcon={<EditIcon />}
                  variant="outlined"
                  onClick={() => this.toggleCreate(procedure)}
                  disableElevation
                >
                  Editar
                </Button>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ))}

        <div className="info-header noselect">
          <p>
            <span>Observação</span>
          </p>
          <Row>
            <Input
              className="txt-observacao"
              type="textarea"
              label="Digite aqui sua observação (opcional)"
              onChange={this.handleObservacao}
              value={this.state.observacoes}
              maxLength="500"
              l={12}
              m={12}
              s={12}
              xl={12}
            />
          </Row>
        </div>

        <div className="btn-orange-container">
          <Button
            className="btn-orange"
            color="primary"
            variant="contained"
            disableElevation
            disabled={btnDisabled}
            onClick={() => this.handleCreateGto()}
          >
            Criar GTO
          </Button>
        </div>

        <ModalBox
          modalActive={modalActive}
          modalLabel={procedure ? 'Editar Procedimento' : 'Incluir Procedimento'}
          onChange={this.toggleCreate}
          style={{ padding: '15px 15px 150px 15px' }}
        >
          <CardBoxTreatmentPlan type="blue" data={updatedPlans} />

          <NewProcedure
            addProcedure={this.addProcedure}
            editProcedure={this.editProcedure}
            procedure={procedure}
            codigoPrestador={this.props.codigo}
            updatedPlans={updatedPlans}
          />

        </ModalBox>

        <Dialog
          maxWidth="xs"
          open={alertGtoExclusiva}
          onClose={() => this.setState({ alertGtoExclusiva: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{ textAlign: 'center', color: '#1b365d' }}>
            <strong>Operação inválida!</strong>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText style={{ color: '#212121', fontSize: 15, textAlign: 'center' }}>
              {alertGtoExclusivaMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'space-around', color: '#dc6b2f' }}>
            <Button
              onClick={() => this.setState({ alertGtoExclusiva: false })}
              color="inherit"
              style={{ width: '90%', fontSize: '1rem' }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth="xs"
          open={alertCreatedGto}
          onClose={this.handleOkCriar}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{ textAlign: 'center', color: '#1b365d' }}>
            <strong>GTO criada!</strong>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText
              style={{ color: '#212121', fontSize: 15, textAlign: 'center', margin: 0 }}
            >
              {`A GTO ${this.state.numeroGto} foi criada com sucesso. É necessário
              imprimir para datar e solicitar assinatura do paciente.`}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'space-around', color: '#dc6b2f' }}>
            <Button
              onClick={this.handleOkCriar}
              color="inherit"
              style={{ width: '90%', fontSize: '1rem' }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth="xs"
          open={alertPreAprovacao}
          onClose={this.handleBadRequestPreAprovacaoOrto}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{ textAlign: 'center', color: '#1b365d' }}>
            <strong>Prorrogação de Tratamento Ortodôntico!</strong>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText
              style={{ color: '#212121', fontSize: 15, textAlign: 'justify', margin: 0 }}
            >
              <p>Prezado(a) Prestador(a), para a próxima solicitação de manutenção ortodôntica, é necessário acessar a jornada pelo Portal Sad.Net, na sua área logada, na aba Tratamentos &gt;&gt; Solicitação de Tratamentos.
                <br /><br />
                Quer acessar mais rapidamente? Clique no link abaixo:
                <br />
                <a href='http://prestadorodontop.sulamerica.com.br/sadnet/default.aspx?GcHUen0lef4A=WjawBj5Me7wA' target='_blank'>Sad.Net - Serviços OnLine para Prestadores</a>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'space-around', color: '#dc6b2f' }}>
            <Button
              onClick={this.handleBadRequestPreAprovacaoOrto}
              color="inherit"
              style={{ width: '90%', fontSize: '1rem' }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

Procedure.propTypes = {
  updatedPlans: PropTypes.objectOf(PropTypes.any).isRequired,
  codigo: PropTypes.number.isRequired,
  regANS: PropTypes.string.isRequired
};

const mapStateToProps = ({ login }) => ({
  codigo: login.user.codigo
});

export default connect(mapStateToProps)(Procedure);